import React, { useEffect, useState } from 'react';
import Select from 'react-select';
//import AsyncCreatableSelect, { makeCreatableSelect } from 'react-select/async-creatable';
import CreatableSelect, { makeCreatableSelect } from 'react-select/creatable';
import { Form } from 'react-bootstrap';

const SearchSelectbox = React.memo((props) => {
    const [value, setValue] = useState(null);

    const formHandler = props.formHandler;
    const error = formHandler.errors[props.name];
    const touched = formHandler.touched[props.name];
    const tmpVal = formHandler.values[props.name];

    useEffect(() => {
        const val = props.options.filter(option => option.value === tmpVal)
        if (val.length > 0) {
            setValue(val[0]);
        } else {
            setValue(null);
        }
    }, [tmpVal, props.options])

    //useEffect(() => {
    //    const val = props.options.filter(option => option.value === tmpVal)
    //    if (val.length > 0) {
    //        setValue(val[0]);
    //    } else {
    //        setValue(null);
    //    }
    //}, [props.options])

    const handleChange = (newValue, actionMeta) => {
        console.group('Value Changed');
        console.log(newValue);
        console.log(`action: ${actionMeta.action}`);
        console.groupEnd();
        formHandler.setFieldValue(props.name, newValue?.id, true)
    };

    const onBlur = () => {
        formHandler.setFieldTouched(props.name, true);
    }

    const handleCreate = (newValue) => {
        console.group('Value Created');
        console.log(`New value: ${newValue}`);
        console.groupEnd();
        props.onCreate(newValue);
    };

    const handleInputChange = (inputValue, actionMeta) => {
        console.group('Input Changed');
        console.log(inputValue);
        console.log(`action: ${actionMeta.action}`);
        console.groupEnd();
    }

    return (
        <>
            <Form.Label>{props.label}</Form.Label>
            <CreatableSelect
                className={touched && error ? "custom-error-control is-invalid" : ""}
                placeholder={props.placeholder}
                name={props.name}
                isClearable
                value={value}
                onChange={handleChange}
                onBlur={onBlur}
                onInputChange={handleInputChange}
                onCreateOption={handleCreate}
                options={props.options}
                isInvalid={touched && error}
            />
            <small className={error && props.helpText ? "d-none" : "form-text text-muted"}>{props.helpText}</small>
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        </>
    );
})

export default SearchSelectbox;